module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 44300.985c2b92.png";